/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Singular account-scoped resource: /api/v1/accounts/:accountId/client_settings
// (no id segment), so `get`/`update` target the base url directly.
class ClientSettingsAPI extends ApiClient {
  constructor() {
    super('client_settings', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }
}

export default new ClientSettingsAPI();
